<template>
    <div class="post-tag disable-select" v-dragscroll>
        <v-chip v-if="Number(post.offer_type) === $variables.v.offer_types.giveaway && Number(post.points) >= $variables.v.post_trending_giveaway_requirement">
            <span v-html="$th('post.popular')"></span>
        </v-chip>
        <v-chip v-if="Number(post.offer_type) === $variables.v.offer_types.deal && Number(post.points) >= $variables.v.post_hot_deals_requirement">
            <span v-html="$th('post.popular')"></span>
        </v-chip>
        <v-chip v-if="post.itemtypeID"><span v-html="$th($variables.v.itemtypes.find(x => x.id === Number(post.itemtypeID)).text)"></span></v-chip>
        <v-chip v-if="post.serviceID"><span v-html="$th($variables.v.services.find(x => x.id === Number(post.serviceID)).text)"></span></v-chip>
        <v-chip v-if="post.vpn_required === '1'"><span v-html="$th('post.vpn')"></span></v-chip>
        <v-chip v-if="post.key_giveaway === '1'"><span v-html="$th('post.keys')"></span></v-chip>
        <v-chip v-if="post.base_game_not_free === '1'"><span v-html="$th('post.paid-base-game')"></span></v-chip>
        <v-chip v-if="remaining_days <= 0 && remaining_days > -1"><span v-html="$th('post.last-day')"></span></v-chip>
    </div>
</template>

<script>
    import {dragscroll} from 'vue-dragscroll'


    export default {
        props     : ['post'],
        data() {
            return {
                remaining_days: 0,
            }
        },
        beforeMount() {
            this.remaining_days = this.calc_remaining_days(this.post.expiration_date);
        },
        methods   : {
            calc_remaining_days(date) {
                let eventdate  = this.moment(date);
                let todaysdate = this.moment();
                return eventdate.diff(todaysdate, 'days');
            },
        },
        directives: {
            'dragscroll': dragscroll
        },

    }
</script>
